import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {mc} from '@px/helper/mc';
import {sd} from '@px/da';
import {userApi} from '@px/api/user';
import {isLogin$} from '@px/streams/auth';
import {wwData$} from '@px/streams/worker-data';
import {userInfo$} from '@px/streams/user';

export const PILOT_CONTRACT_BIZ_KEY = 'pilotPerpSetting';

export const contractBizEvents$ = wwData$.pipe(
  filter((o) => o.type === 'contract-biz'),
  map((o) => o.data)
);

export const contractBiz$ = new BehaviorSubject([]);

isLogin$.pipe(filter(Boolean)).subscribe(() => getCustomize());

contractBizEvents$.pipe(filter((events) => events?.some(({eventType}) => ['slippageSetting', PILOT_CONTRACT_BIZ_KEY].includes(eventType)))).subscribe(() => getCustomize());

export const isActivePilotContractTrade$ = new BehaviorSubject(true);

export async function getCustomize() {
  const {data, error} = await userApi.customizeQuery();
  if (data) {
    contractBiz$.next(data);
    const userInfo = userInfo$.getValue();
    if (userInfo.isMain) {
      const info = getContractBizInfo(data, PILOT_CONTRACT_BIZ_KEY).bizVal || {status: false};
      isActivePilotContractTrade$.next(!!info.status);
    }
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}

export async function updateCustomize({bizKey, curVersion, settings}) {
  const version = curVersion + 1;
  const params = {bizVal: JSON.stringify(settings), bizKey, version};
  sd.track('submit_request', {action: 'update_customize_biz', ...params});
  const {data, error} = await userApi.customizeBiz(params);
  if (data) {
    return version;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  return -1;
}

export function getContractBizInfo(contractBiz, key) {
  const info = contractBiz.find((o) => o.bizKey === key);
  return info
    ? {
        ...info,
        bizVal: JSON.parse(info.bizVal),
      }
    : {
        version: 0,
        userId: 0,
        bizKey: key,
        bizVal: null,
      };
}
